import script from "./firm-inbox-company-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./firm-inbox-company-panel.vue?vue&type=script&setup=true&lang=js"

import "./firm-inbox-company-panel.vue?vue&type=style&index=0&id=8bf5f1b5&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bf5f1b5"]])

export default __exports__